/* ===== Anadita Luxe — slideshow ===== */
(function () {
  'use strict';
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-slide-to]'));
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
    }
    var next = root.querySelector('[data-slide-next]'), prev = root.querySelector('[data-slide-prev]');
    if (next) next.addEventListener('click', function () { go(i + 1); reset(); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.slideTo, 10)); reset(); }); });
    function reset() { if (timer) { clearInterval(timer); auto(); } }
    function auto() {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;
      var speed = parseInt(root.dataset.speed, 10) || 6000;
      timer = setInterval(function () { go(i + 1); }, speed);
    }
    auto();
  });
})();
